import React, { createContext, useEffect, useState } from "react";
import { getApplicationVersion } from "@specsheet-common/shared-tools";
import { socketMessageKinds } from "@specsheet-common/shared-types";
import { useWebsocket } from "../hooks/contexts/useWebsocket";

interface ApplicationVersion {
  version: string | null;
  setVersion(version: string): void;
}

export const ApplicationVersionContext = createContext<ApplicationVersion>({
  version: getApplicationVersion(),
  setVersion: () => {},
});

export const ApplicationVersionProvider: React.FC = ({ children }) => {
  const [state, setState] = useState(getApplicationVersion());
  const { wsSubscribe } = useWebsocket();

  useEffect(() => {
    wsSubscribe[socketMessageKinds.applicationVersion].subscribe(setState);
    return () => {
      wsSubscribe[socketMessageKinds.applicationVersion].unsubscribe();
    };
  }, []);

  return (
    <ApplicationVersionContext.Provider
      value={{ version: state, setVersion: setState }}
    >
      {children}
    </ApplicationVersionContext.Provider>
  );
};
